'use client';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import Button from '@ui/Button';
import { useAuth } from 'context/AuthContext';

export const FollowButton = () => {
  const { userDoc } = useAuth();
  const isFollowing = userDoc?.following.includes(
    'XlSW5m16C5UwUJXg9VP0iyWKi3A2'
  );
  return (
    <Button
      type={isFollowing ? 'greenBg' : 'secondary'}
      text={isFollowing ? 'You already follow Jeff Emig!' : 'Follow Jeff Emig'}
      className="lg:mt-8"
      radius={'xl'}
      trailingIcon={<ChevronRightIcon className="h-10 w-10" />}
      href={`/profile/emig47`}
    />
  );
};
